var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJobPreferanceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4C4 4 3 5 3 6c0 2 1 3 3 3h12c2 0 3-1 3-3 0-1-1-2-3-2H6zM4 11c-1 0-1 1-1 1s0 1 1 1h16c1 0 1-1 1-1s0-1-1-1H4zM3 16c0-1 0-1 1-1h16c1 0 1 0 1 1 0 0 0 1-1 1H4c-1 0-1-1-1-1zM4 19c-1 0-1 0-1 1h18c0-1 0-1-1-1H4z",
    fill: "#C5A537"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobPreferanceIcon);
export default __webpack_public_path__ + "static/media/job-preferance-icon.7a650b61dda0c4fcf45a6aa75466c443.svg";
export { ForwardRef as ReactComponent };